var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C10.1867 12 11.3467 11.6481 12.3334 10.9888C13.3201 10.3295 14.0892 9.39246 14.5433 8.2961C14.9974 7.19975 15.1162 5.99335 14.8847 4.82946C14.6532 3.66558 14.0818 2.59648 13.2426 1.75736C12.4035 0.918247 11.3344 0.346802 10.1705 0.115291C9.00666 -0.11622 7.80026 0.00259972 6.7039 0.456726C5.60754 0.910851 4.67047 1.67989 4.01118 2.66658C3.35189 3.65328 3 4.81331 3 6V9.1L1.2 7.3L0.5 8L3.5 11L6.5 8L5.8 7.3L4 9.1V6C4 5.0111 4.29324 4.0444 4.84265 3.22215C5.39206 2.39991 6.17295 1.75904 7.08658 1.38061C8.00021 1.00217 9.00555 0.90315 9.97545 1.09608C10.9454 1.289 11.8363 1.76521 12.5355 2.46447C13.2348 3.16373 13.711 4.05465 13.9039 5.02455C14.0969 5.99446 13.9978 6.99979 13.6194 7.91342C13.241 8.82705 12.6001 9.60794 11.7779 10.1574C10.9556 10.7068 9.98891 11 9 11V12Z",
    fill: "#15141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.a103f5da9e4a3aac0fee3524b3a88301.svg";
export { ForwardRef as ReactComponent };